import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import overviewReducer from './slices/overviewSlice';


const store = configureStore({
  reducer: {
    auth: authReducer,
    overview: overviewReducer,
  },
});

export default store;
